/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Snapshot_History_Username_LabelInputs */



/**
* | output |
* | --- |
* | "Username" |
*
* @param {Snapshot_History_Username_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const snapshot_history_username_label = /** @type {((inputs?: Snapshot_History_Username_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Snapshot_History_Username_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nom d'utilisateur")
	if (locale === "de") return /** @type {LocalizedString} */ ("Benutzername")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nome utente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Имя пользователя")
	if (locale === "es") return /** @type {LocalizedString} */ ("Nombre de usuario")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("用户名")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ユーザー名")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उपयोगकर्ता नाम")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nome de usuário")
	return /** @type {LocalizedString} */ ("Username")
});